import React from 'react'
import { IVehicleTypeModel } from './VehicleTypeModel'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'

type Props = {
  data: IVehicleTypeModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (row: IVehicleTypeModel) => void
  onDelete?: (row: IVehicleTypeModel) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const VehicleTypeTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
 
  const vehicleTypeColumns: TableColumn<IVehicleTypeModel>[] = [
    { key: 'name', label: 'Araç Tipi (Model)', className: 'fw-semibold', sortable: true },
    { key: 'brand.name', label: 'Marka', sortable: true },
    { key: 'vehicleGroup.groupName', label: 'Araç Grubu', sortable: true },
    { key: 'transmission', label: 'Vites', sortable: true },
    { key: 'fuelType', label: 'Yakıt Türü', sortable: true },
  ]

  const vehicleTypeActions: TableAction<IVehicleTypeModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (row) => onEdit?.(row),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (row) => onDelete?.(row),
    },
  ]

  return (
    <DataTable
      data={data}
      columns={vehicleTypeColumns}
      actions={vehicleTypeActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz araç tipi bulunamadı'
    />
  )
}

export default VehicleTypeTable
